"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var creative_1 = require("./creative");
var fill_1 = require("./fill");
var outline_1 = require("./outline");
var notificationCenter_1 = require("./notificationCenter");
var logo_1 = require("./logo");
exports.Icon = {
    Creative: creative_1.Creative,
    Fill: fill_1.Fill,
    Outline: outline_1.Outline,
    NotificationCenter: notificationCenter_1.NotificationCenter,
    Logo: logo_1.Logo,
};
